// eslint-disable-next-line lumapps/do-not-import-react-query
import * as rq from '@tanstack/react-query';

/**
 * Create a default React Query client to ensure setup consistencies everywhere throughout apps and packages.
 *
 * ℹ️ We make sure `refetchOnWindowFocus`is disabled (can be overriden)
 * ℹ️ We make sure retries are disabled on both queries and mutations (can be overriden)
 */
export const createQueryClient = (config: rq.QueryClientConfig | undefined = {}) =>
    new rq.QueryClient({
        ...config,
        defaultOptions: {
            ...config.defaultOptions,
            mutations: {
                retry: false,
                ...config.defaultOptions?.mutations,
            },
            queries: {
                retry: false,
                refetchOnWindowFocus: false,
                ...config.defaultOptions?.queries,
            },
        },
    });
